export default __webpack_public_path__ + "static/media/digitalclock.947b5b2d.png";